const maintainAlertReducers = (
  state = {
    maintainTime: 0,
    state: false,
  },
  action
) => {
  switch (action.type) {
    case "SHOW_MAINTAIN_ALERT":
      return {
        maintainTime: action.payload.maintainTime,
        state: action.payload.state,
      };
    case "HIDE_MAINTAIN_ALERT":
      return {
        maintainTime: 0,
        state: false,
      };
    default:
      return {
        maintainTime: 0,
        state: false,
      };
  }
};
export default maintainAlertReducers;
